<template>
  <div class="form-field" :class="{ 'has-error': v.$error }">
    <label v-if="label" :for="name">{{ label }}: <span v-if="v">*</span></label>
    <div class="input-wrap">
      <div
        v-if="type === 'password'"
        class="input-eye"
        :class="{ 'input-eye--show': showPassword }"
        @click.prevent="switchInputType"
      ></div>
      <div v-if="copy" class="input-copy" @click.prevent="copyInput"></div>

      <input
        :id="name"
        ref="input"
        :class="{ '-dark-border': darkBorder }"
        :name="name"
        :data-cy="name"
        :type="inputType"
        :readonly="readonly"
        :value="$attrs.value"
        @input="$emit('input', $event.target.value)"
      />
    </div>

    <div class="errors">
      <div v-if="v && !v.required">{{ $t("field_is_required") }}</div>
      <div v-if="v && v.email !== undefined && !v.email">
        {{ $t("email_validation") }}
      </div>
      <div v-if="v && v.alphaNum !== undefined && !v.alphaNum">
        {{ $t("alphanumeric_validation") }}
      </div>
      <div v-if="v && v.minLength !== undefined && !v.minLength">
        {{ $t("field_length_validation", { length: v.$params.minLength.min }) }}
      </div>
      <div v-if="v && v.maxLength !== undefined && !v.maxLength">
        {{
          $t("field_maxlength_validation", { length: v.$params.maxLength.max })
        }}
      </div>
      <div
        v-if="v && v.passwordValidation !== undefined && !v.passwordValidation"
      >
        {{ $t("password_validation") }}
      </div>
      <div v-if="v && v.sameAsPassword !== undefined && !v.sameAsPassword">
        {{ $t("same_password_validation") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    v: {
      type: [Boolean, Object],
      default: () => {
        return false;
      }
    },
    darkBorder: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "text"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    inputType() {
      if (this.showPassword) {
        return "text";
      }

      return this.type;
    }
  },
  methods: {
    switchInputType() {
      if (this.showPassword) {
        this.showPassword = false;
      } else {
        this.showPassword = true;
      }
    },
    copyInput() {
      this.$refs.input.select();
      document.execCommand("copy");
    }
  }
};
</script>

<style lang="scss" scoped>
.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

label {
  font-size: 12px;
  line-height: 1;
  color: $white-60;
  text-transform: uppercase;
  margin-bottom: 10px;

  span {
    font-size: 16px;
    color: #ff0000;
  }
}

input {
  width: 100%;
  background-color: transparent;
  border: 2px solid $white-40;
  height: 50px;
  padding: 0 25px;
  font-size: 18px;
  color: $white;

  &[disabled="disabled"],
  &[readonly="readonly"] {
    background: rgba(39, 39, 39, 0.1);
  }
}

.input-wrap {
  position: relative;
}

.input-eye {
  background: url("~@/assets/img/svg/eye-close.svg") no-repeat;
  width: 20px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: calc(50% - 5px);
  cursor: pointer;
  // opacity: 0.4;
  transition: opacity 300ms ease;

  &:hover {
    opacity: 0.8;
  }

  & + input {
    padding-right: 33px;
  }

  &--show {
    background: url("~@/assets/img/png/eye.png") no-repeat center bottom;
    top: calc(50% - 8px);
  }
}

.input-copy {
  background: url("~@/assets/img/svg/copy.svg") no-repeat;
  width: 20px;
  height: 19px;
  position: absolute;
  right: 10px;
  top: calc(50% - 9.5px);
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 300ms ease;

  &:hover {
    opacity: 1;
  }

  & + input {
    padding-right: 33px;
  }
}

.-dark-border {
  border: 2px solid #272727;
}

.errors > div {
  color: #ff0000;
  font-size: 11px;
  margin-top: 10px;
  display: none;
}

.has-error {
  input {
    border-color: #ff0000;
  }
  .errors > div {
    display: block;
  }
}

// @media screen and (max-height: 800px) {
//   .form-field {
//     margin-bottom: 15px;
//   }

//   input {
//     height: 40px;
//   }
// }
</style>
